import React from 'react';
import { Alert, Descriptions } from 'antd';
import { money } from '../payments-v2/utilities/paymentPresentation';
export default function InvoiceRevisionReview({ payload = {} }) {
  const evidence = payload.evidence || {};
  return <><Descriptions bordered size="small" column={1}><Descriptions.Item label="Old total">{money(payload.old_total_amount)}</Descriptions.Item><Descriptions.Item label="New total">{money(payload.new_total_amount)}</Descriptions.Item><Descriptions.Item label="Change">{money(payload.delta_amount)}</Descriptions.Item><Descriptions.Item label="Reason">{payload.reason_code} · {payload.note}</Descriptions.Item></Descriptions>
    {evidence.cost_unchanged && <Alert type="warning" message="Cost unchanged" />}
    <Alert type="info" message="Line-by-line revision evidence awaits a documented field contract" />
  </>;
}
